import React, { useEffect } from "react";
import ContentBox from "../../components/ContentBox/ContentBox";
import Heading from "../../components/Heading/Heading";
import { events } from "../../data/contents";

function BNB() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Heading text="Brains and Brawn" subtext="Vyuhaa'22" />
      <ContentBox
        desc={events.bnb.desc}
        venue={events.bnb.venue}
        time={events.bnb.time}
        contacts={events.bnb.contact}
        rounds={events.bnb.round}
        teamSize={events.bnb.teamSize}
        img_src={events.bnb.img_src}
      />
    </div>
  );
}

export default BNB;